import { Backdrop, color, Modal, radius } from '@gyym/ui'
import styled, { keyframes } from 'styled-components'

const arrowUp = keyframes`
  from {
    transform: translate(0, 0);
  }
  to {
    /* 矢印の画像素材の高さと幅に合わせる */
    transform: translate(104px, -104px);
  }
`

const arrowDown = keyframes`
  from {
    transform: translate(0, 0);
  }
  to {
    /* 矢印の画像素材の高さと幅に合わせる */
    transform: translate(104px, 104px);
  }
`

const rankUpToLeft = keyframes`
  from {
    transform: translate(0, 0);
  }
  to {
    transform: translate(119px, 0);
  }
`

const rankUpToRight = keyframes`
  from {
    transform: translate(0, 0);
  }
  to {
    transform: translate(-119px, 0);
  }
`

const rankDownSlideUp = keyframes`
  from {
    transform: translate(0, -100%);
  }
  to {
    transform: translate(0, 0);
  }
`

const rankDownSlideDown = keyframes`
  from {
    transform: translate(0, 100%);
  }
  to {
    transform: translate(0, 0);
  }
`

const questClearToLeft = keyframes`
  0% {
    transform: translate(-84px, 0);
  }
  30% {
    transform: translate(84px, 0);
  }
  100% {
    transform: translate(84px, 0);
  }
`

const bump = keyframes`
  0% {
    transform: scale(0.9);
  }
  50% {
    transform: scale(1);
  }
  100% {
    transform: scale(0.9);
  }
`

const shrinkDown = keyframes`
  0% {
    transform: translate(0, 0) scale(1);
  }
  90% {
    transform: translate(0, 20px) scale(0.8);
  }
  100% {
    transform: translate(0, 0) scale(1);
  }
`

export const ArrowUpBackdrop = styled(Backdrop)`
  overflow: hidden;
  background: none;
  position: fixed;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    height: 150%;
    width: 150%;
    opacity: 0.6;
    background: url(/assets/images/pass/bg_arrow_grade_up.png) 0% 0% / 104px
      repeat;
    animation: ${arrowUp} 1.5s linear infinite;
  }
`

export const ArrowDownBackdrop = styled(Backdrop)`
  overflow: hidden;
  background: none;
  position: fixed;

  &::after {
    content: '';
    position: absolute;
    top: -20%;
    right: 0;
    height: 150%;
    width: 150%;
    opacity: 0.6;
    background: url(/assets/images/pass/bg_arrow_grade_down.png) 0% 0% / 104px
      repeat;
    animation: ${arrowDown} 1.5s linear infinite;
  }
`

export const StyledModal = styled(Modal)`
  max-width: 320px;
  width: 90%;
  min-height: 436px;
  max-height: 95vh;
  background: ${color('white')} url(/assets/images/pass/modal_background.png)
    center/100% no-repeat;
  border-radius: ${radius('lg')};
  display: flex;
  flex-direction: column;
  overflow: hidden;

  &.grade-up {
    &::before {
      content: '';
      position: absolute;
      top: 0;
      width: calc(100% + 119px);
      height: 35px;
      right: -119px;
      background: url(/assets/images/pass/modal_belt_top_grade_up.png) 0% 0% /
        119px repeat-x;
      animation: ${rankUpToRight} 3s linear infinite;
    }

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      width: calc(100% + 119px);
      height: 35px;
      left: -119px;
      background: url(/assets/images/pass/modal_belt_bottom_grade_up.png) 0% 0% /
        119px repeat-x;
      animation: ${rankUpToLeft} 3s linear infinite;
    }
  }

  &.grade-down {
    &::before {
      content: '';
      position: absolute;
      top: 0;
      width: 100%;
      height: 174px;
      background: url(/assets/images/pass/modal_belt_top_grade_down.png) 0% 0% /
        cover no-repeat;
      animation: ${rankDownSlideUp} 2.8s ease;
    }

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 39px;
      background: url(/assets/images/pass/modal_belt_bottom_grade_down.png) 0%
        0% / cover no-repeat;
      animation: ${rankDownSlideDown} 4.5s ease;
    }
  }

  &.quest-clear {
    &::before {
      content: '';
      position: absolute;
      top: 0;
      width: calc(100% + 336px);
      height: 35px;
      left: -168px;
      background: url(/assets/images/pass/modal_belt_top_quest_clear.png) 0% 0% /
        168px repeat-x;
      animation: ${questClearToLeft} 2s ease infinite;
    }

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      width: calc(100% + 336px);
      height: 35px;
      left: -168px;
      background: url(/assets/images/pass/modal_belt_bottom_quest_clear.png) 0%
        0% / 168px repeat-x;
      animation: ${questClearToLeft} 2s ease infinite;
    }
  }
`

export const GradeBadge = styled.div`
  &.bump {
    animation: ${bump} 0.5s ease infinite;
  }

  &.shrink-down {
    animation: ${shrinkDown} 3s ease infinite;
  }
`
